import { Col } from "antd";
import Slider from "react-slick";

import Authors from "./Authors";
import { ManyAuthorsContainer } from "./styles";

const ManyAuthors = ({ authors }) => {
  const options = {
    dots: false,
    infinite: true,
    speed: 500,
    marginLeft: 10,
    marginRight: 10,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <ManyAuthorsContainer>
      <Col span={24}>
        <Slider {...options}>
          {authors.map((author) => (
            <Authors key={author.id} author={author} />
          ))}
        </Slider>
      </Col>
    </ManyAuthorsContainer>
  );
};

export default ManyAuthors;
